import React, { memo } from 'react'
import { FormControlLabel, Radio } from '@mui/material'

import DisplayLabel from '../DisplayLabel/DisplayLabel'

const RadioButton = ({ value, label }) => {
  return (
    <FormControlLabel
      value={value}
      control={
        <Radio
          sx={{
            '& .MuiSvgIcon-root': {
              fontSize: 16
            }
          }}
        />
      }
      label={<DisplayLabel value={label} />}
    />
  )
}

export default memo(RadioButton)
